import React from 'react';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  padding: 0 20rem;
  overflow-y: auto;
`;

const Text = styled.p`
  margin: 20rem 0;
  text-align: justify;

  &.bold, span { font-weight: bold }

  &.updated {
    margin-top: 30rem;
    margin-bottom: 0;

    font-size: 13rem;
    font-style: italic;
    text-align: end;
  }
`;

const Body = () => (
  <Wrapper>
    <Text className="bold">
      This website is not in anyway affiliated or represents <a href="https://www.somersby.com/en/homepage" target="_blank" rel="noreferrer">Somersby</a>.
      This website is a form of speculative work performed to showcase website development skill.
    </Text>

    <Text>
      Copyright Disclaimer Under Section 107 of the Copyright Act 1976: Allowance is made for “fair use” for purposes
      such as criticism, comment, news reporting, teaching, scholarship, education, and research. Fair use is a use
      permitted by copyright statute that might otherwise be infringing.
    </Text>

    <Text>
      This website aggregate contents from the official website for informational purposes, and is in no way trying to
      infringe on the copyrights or businesses of any of the entities.
    </Text>

    <Text>
      If it is the organization’s belief that the usage of specific content used on this website containing copyrighted
      knowledge conflicts with authorized use, and/or does not comply with fair use as described in this context, please
      contact the developer through <span>hojiajin7@gmail.com</span> to facilitate the removal of offending content immediately.
    </Text>

    <Text className="updated">Last updated 27/12/2021</Text>
  </Wrapper>
);

export default Body;